module.exports = __webpack_public_path__ + "static/media/ee_mob_r.b750c7a5.png";